import ReactGA from "react-ga4";
import config from "./appConfig";

const ANALYTICS_ID = config["GOOGLE-ANALYTICS-ID"];

export const initAnalytics = () => {
  if (ANALYTICS_ID && !ANALYTICS_ID.startsWith("#{")) {
    ReactGA.initialize(ANALYTICS_ID);
  }
};

export const trackPageView = (path: string) => {
  if (ANALYTICS_ID && !ANALYTICS_ID.startsWith("#{")) {
    ReactGA.send({ hitType: "pageview", page: path });
  }
};
